module.exports = __webpack_public_path__ + "alphabetical_sorting_2.svg";